import { render, staticRenderFns } from "./LoginOkta.vue?vue&type=template&id=1ec96e18&"
import script from "./LoginOkta.vue?vue&type=script&lang=js&"
export * from "./LoginOkta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports